import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { getAllCaseStudiesMeta } from '../lib/casestudies';

export function CaseStudiesListing() {
  const caseStudies = getAllCaseStudiesMeta();

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Page Header */}
      <section className="py-16 md:py-24 bg-bg-gray-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-text-dark text-center mb-6">
            Case Studies
          </h1>
          <p className="text-center text-lg md:text-xl text-text-gray max-w-3xl mx-auto">
            We worked with startups, marketing agencies, insurance, medical. See all case studies.
          </p>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {caseStudies.map((caseStudy) => (
              <Link
                key={caseStudy.slug}
                to={`/casestudies/${caseStudy.slug}`}
                className="bg-white rounded-lg border border-border-gray overflow-hidden hover:shadow-xl transition-shadow"
              >
                <img
                  src={caseStudy.image}
                  alt={caseStudy.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-text-dark mb-2">
                    {caseStudy.title}
                  </h3>
                  <p className="text-text-gray mb-4">{caseStudy.subtitle}</p>
                  <div className="text-primary-blue font-medium">
                    Read more →
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-bg-gray-light">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6">
            Ready to Build Your Own Success Story?
          </h2>
          <Link
            to="/book"
            className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-blue hover:bg-dark-blue transition-colors"
          >
            Get Started Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
